import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

export const releaseVersion = () => getGlobalProperty<string>("releaseVersion");
